import styles from './index.less';
import img from 'asset/home/error.png';
import { setHospitalTDK } from 'utils/hospital';
export const ErrorComp = (props: any) => {
  const {tip = "很抱歉，内容丢失啦～"} = props || {}
  setHospitalTDK('404', '404', '404');
  return <div className={styles.error404}>
    <div className={styles.container}>
      <img src={img} alt={tip} />
      <span>{tip}</span>
    </div>
  </div>
}